import React from "react";
import EditableImage from "../../../components/atoms/editableImage";

const UserImg = ({ data,profilePic, setProfilePic }) => {
  const imageUrl = profilePic
    ? URL.createObjectURL(profilePic)
    : data?.imageUrl?.url;
  return (
    <>
      <div className="border border-1 card card-custom card-stretch">
        <div className="card-body text-center p-5">
          <div className="user_image my-10">
            <EditableImage
              url={imageUrl}
              onChange={(e) => {
                const file = e.target.files[0];
                setProfilePic(file);
              }}
            />
          </div>

          <div className="reward_text">
            <p className="font-size-h4 font-weight-bolder m-0 text-dark-75">
              {data?.name?.en}
            </p>
            <p className="font-size-md font-weight-bold m-0 my-1 text-dark-50">
              {data?.email}
            </p>
            <p className="font-size-md font-weight-bold m-0 my-1 text-dark-50">
              +91-{data?.phone?.dialNumber}
            </p>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserImg;
